export { default as Img200 } from './processed/200/Myths&Monsters.jpg';
export { default as Img400 } from './processed/400/Myths&Monsters.jpg';
export { default as Imgthumb } from './processed/thumb/Myths&Monsters.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Myths&Monsters.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Myths&Monsters.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      183,
      129,
      87
    ],
    "_population": 2172,
    "_hsl": [
      0.07291666666666666,
      0.4,
      0.5294117647058824
    ]
  },
  "LightVibrant": {
    "_rgb": [
      222,
      192,
      134
    ],
    "_population": 1324,
    "_hsl": [
      0.10984848484848485,
      0.5714285714285715,
      0.6980392156862745
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      136,
      60,
      28
    ],
    "_population": 2,
    "_hsl": [
      0.04938271604938271,
      0.6585365853658537,
      0.32156862745098036
    ]
  },
  "Muted": {
    "_rgb": [
      151,
      108,
      75
    ],
    "_population": 913,
    "_hsl": [
      0.07236842105263157,
      0.336283185840708,
      0.44313725490196076
    ]
  },
  "LightMuted": {
    "_rgb": [
      150,
      156,
      150
    ],
    "_population": 11,
    "_hsl": [
      0.3333333333333333,
      0.02941176470588239,
      0.6000000000000001
    ]
  },
  "DarkMuted": {
    "_rgb": [
      78,
      66,
      59
    ],
    "_population": 2617,
    "_hsl": [
      0.06140350877192984,
      0.1386861313868613,
      0.2686274509803922
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Myths&Monsters.js